export const hasPendingCustomisedRestoreForHandout = ({
    contentId,
    forcePendingCustomisedHandoutId,
    pendingCustomisedHandoutSave,
    pendingCombinedHandoutSave,
    onParseError = console.error,
}) => {
    if (!contentId) return false;
    if (forcePendingCustomisedHandoutId === contentId) return true;

    return [
        ['pendingCustomisedHandoutSave', pendingCustomisedHandoutSave],
        ['pendingCombinedHandoutSave', pendingCombinedHandoutSave],
    ].some(([key, raw]) => {
        try {
            if (!raw) return false;
            const data = JSON.parse(raw);
            return data?.handoutId === contentId;
        } catch (error) {
            onParseError(`[HandoutViewer] Failed to inspect ${key}:`, error);
            return false;
        }
    });
};
